import { render, staticRenderFns } from "./ScreenRunByPin.vue?vue&type=template&id=05286ba2&scoped=true"
import script from "./ScreenRunByPin.vue?vue&type=script&lang=js"
export * from "./ScreenRunByPin.vue?vue&type=script&lang=js"
import style0 from "./ScreenRunByPin.vue?vue&type=style&index=0&id=05286ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05286ba2",
  null
  
)

export default component.exports